import { IRestfulConfigMap } from "@core/data-access/restful";
import { envConfig } from "@env/env-config";
let AddressRestsServiceConfig: IRestfulConfigMap = {
    "addressRestsService": {
        // TODO base对应接口地址
        appPath: envConfig.appPath("base"),
        isAuth: true,
        actions: {
            // 新增地址簿
            // addAddressBook
            save: {
                method: "post",
                path: "api/partner/addressBooks",
                testPath: "api/partner/addressBooks"
            },
            // 查询指定ID的地址簿
            // searchAddressBookById
            search: {
                method: "get",
                path: "api/partner/addressBooks/:addressBookId",
                testPath: "api/partner/addressBooks/:addressBookId",
                paramDefaults: { addressBookId: "@addressBookId" }
            },
            // 根据地址簿id删除地址簿
            // deleteAddressBookById
            deleteOne: {
                method: "delete",
                path: "api/partner/addressBooks/:id",
                testPath: "api/partner/addressBooks/:id",
                paramDefaults: { id: "@id" }
            },
            // 批量删除地址簿
            // deleteAddressBooks
            delete: {
                method: "delete",
                path: "api/partner/addressBooks",
                testPath: "api/partner/addressBooks",
                paramDefaults: { ids: "@ids" }
            },
            // 根据地址簿id修改地址簿
            // updateAddressBookById
            update: {
                method: "put",
                path: "api/partner/addressBooks/:addressBookId",
                testPath: "api/partner/addressBooks/:addressBookId",
                paramDefaults: { addressBookId: "@addressBookId" }
            },
            // 获取地址簿列表
            // getAddressBooks
            getAddress: {
                method: "get",
                path: "api/partner/addressBooks",
                testPath: "api/partner/addressBooks"
            },
            // 获取默认地址簿
            // getDefaultAddressBook
            getDefaultAddress: {
                method: "get",
                path: "api/partner/addressBooks/default",
                testPath: "api/partner/addressBooks/default"
            },
            // 校验地址
            // checkAddress
            checkAddress: {
                method: "post",
                path: "api/partner/addressBooks/check",
                testPath: "api/partner/addressBooks/check"
            },
        }
    }
}

export { AddressRestsServiceConfig };